import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import { useNavigate } from 'react-router-dom';

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SquareX, SquareCheck } from 'lucide-react';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from '../common/function';

function RiskTrx() {
    let dispatch = useDispatch()
    let navigate = useNavigate();

    let MyData = useSelector((state) => { return state.MyData })

    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(20)
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)

    const [message, setMessage] = useState("")
    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [combineList, setCombineList] = useState([])
    const [reload, setReload] = useState(false)

    // 필터 상태
    const [anomalyType, setAnomalyType] = useState("")
    const [userId, setUserId] = useState("")
    const [minAmount, setMinAmount] = useState("")
    const [maxAmount, setMaxAmount] = useState("")
    const [sortBy, setSortBy] = useState("created_at")
    const [sortOrder, setSortOrder] = useState("DESC")

    const [listState, setListState] = useState(false)

    // 상세 조회 모달
    const [detailModal, setDetailModal] = useState(false);
    const [detailData, setDetailData] = useState(null);
    const [relatedTransactions, setRelatedTransactions] = useState([]);
    const [memo, setMemo] = useState("");


    // 기간 포맷
    const inputRef = useRef(null);
    const pickerRef = useRef(null);

    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false,
            format: 'YYYY-MM-DD',
            numberOfMonths: 2,
            numberOfColumns: 2,
            showWeekNumbers: true,
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                picker.on('selected', (start, end) => {
                    setPreDate(start.format('YYYY-MM-DD'));
                    setNextDate(end.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            pickerRef.current?.destroy();
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    useEffect(() => {
        dispatch(change_Current_Location("이상거래관리"))
        dispatch(changeHeaderTitle({
            mainTitle: "이상 거래 관리"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    useEffect(() => {
        ListData()
    }, [page, preDate, nextDate, anomalyType, userId, minAmount, maxAmount, sortBy, sortOrder, reload])

    const ListData = async () => {
        if (page === 1) setSpinner(true)
        
        const params = {
            page: page,
            limit: maxFirstPage,
            startDate: preDate,
            endDate: nextDate,
            sortBy: sortBy,
            sortOrder: sortOrder,
        };

        if (anomalyType) params.anomalyType = anomalyType;
        if (userId) params.userId = userId;
        if (minAmount) params.minAmount = minAmount;
        if (maxAmount) params.maxAmount = maxAmount;

        await axios.get(process.env.REACT_APP_API + "/api/risk-trx", {
            withCredentials: true,
            params: params
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? {})
                if (page === 1) {
                    setListTrxData(tmp?.data?.items ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.items ?? []]);
                }
                setListState(e => !e)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            setMessage({ msg: "데이터 조회에 실패했습니다." });
            setSpinner(false)
        });
    }

    // 상세 조회
    const fetchDetail = async (reviewId) => {
        await axios.get(process.env.REACT_APP_API + `/api/risk-trx/${reviewId}`, {
            withCredentials: true
        }).then((response) => {
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setDetailData(tmp?.data);
                setRelatedTransactions(tmp?.data?.related_transactions || []);
                setMemo(tmp?.data?.memo || "");
                setDetailModal(true);
            } else {
                setMessage({ msg: tmp?.msg || "상세 정보 조회에 실패했습니다." });
            }
        }).catch(error => {
            console.error(error);
            setMessage({ msg: "상세 정보 조회에 실패했습니다." });
        });
    };

    // 메모 업데이트
    const updateMemo = async (reviewId) => {
        await axios.patch(
            process.env.REACT_APP_API + `/api/risk-trx/${reviewId}/memo`,
            { memo: memo },
            { withCredentials: true }
        ).then((response) => {
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage({ msg: "메모가 업데이트되었습니다." });
                fetchDetail(reviewId); // 상세 정보 다시 조회
            } else {
                setMessage({ msg: tmp?.msg || "메모 업데이트에 실패했습니다." });
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ msg: "메모 업데이트에 실패했습니다." });
        });
    };

    const onSubmit = async (reviewId, status, memoText = "") => {
        const confirmMsg = status === "CONFIRMED" ? "정상 거래로 확인하시겠습니까?" : "이상 거래로 거부하시겠습니까?";
        if (window.confirm(confirmMsg)) {
            await axios.put(
                process.env.REACT_APP_API + `/api/risk-trx/${reviewId}/status`,
                {
                    review_status: status,
                    memo: memoText,
                    admin_id: MyData?.admin_id,
                },
                {
                    withCredentials: true,
                }
            )
                .then((response) => {
                    let tmp = response?.data;
                    console.log(tmp)
                    if (tmp?.code < 2000) {
                        setMessage({ msg: "상태가 업데이트되었습니다." });
                        setPage(1)
                        setReload((e) => !e);
                    } else {
                        setMessage({ msg: tmp?.msg || "상태 업데이트에 실패했습니다." });
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setMessage({ msg: "상태 업데이트에 실패했습니다." });
                });
        }
    };

    const tableHeaderData = [
        { "no": 0, "text": "검토ID", "width": "80px", "textAlign": "center" },
        { "no": 1, "text": "승인번호", "width": "120px", "textAlign": "center" },
        { "no": 2, "text": "가맹점명", "width": "150px", "textAlign": "center" },
        { "no": 3, "text": "이상거래 유형", "width": "120px", "textAlign": "center" },
        { "no": 4, "text": "금액", "width": "100px", "textAlign": "center" },
        { "no": 5, "text": "거래일시", "width": "150px", "textAlign": "center" },
    ]

    useEffect(() => {
        let tableBodyData = [];
        if (listTrxData) {
            setCombineList(listTrxData)

            for (let i = 0; i < listTrxData.length; i++) {
                let data = listTrxData[i]

                let rowData = [
                    { 
                        "no": 0, 
                        "text": (
                            <span 
                                style={{ cursor: "pointer", color: "#3b82f6", textDecoration: "underline" }}
                                onClick={() => fetchDetail(data.review_id)}
                            >
                                {data.review_id}
                            </span>
                        ), 
                        "width": "80px", 
                        "textAlign": "center" 
                    },
                    { "no": 1, "text": data.approval_id, "width": "120px", "textAlign": "center" },
                    { "no": 2, "text": data.merchant_name || data.user_id, "width": "150px", "textAlign": "left" },
                    { "no": 3, "text": data.anomaly_type_kr || data.anomaly_type, "width": "120px", "textAlign": "center" },
                    { "no": 4, "text": changeNum(Number(data.amount)), "width": "100px", "textAlign": "right" },
                    { "no": 5, "text": data.transaction_dt, "width": "150px", "textAlign": "center" },
                ]

                rowData.id = data.review_id
                tableBodyData.push(rowData);
            }
            setListState(e => !e)
            setCombineData(tableBodyData)
        }
    }, [listTrxData, page, maxFirstPage, reload])

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.total >= page * maxFirstPage) {
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData, listData]);

    const excelBtn = () => {
        // 엑셀 다운로드 기능 (추후 구현)
        setMessage({ msg: "엑셀 다운로드 기능은 준비 중입니다." });
    }

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={message} />
            
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                    />
                    <div className="input_row" style={{ marginTop: "10px", fontSize: "12px", margin: 0 }}>
                        <div className="input_wrap" style={{ margin: 0 }}>
                            <div className="input_item flex" style={{ display: "flex", gap: "8px", alignItems: "center", margin: 0, flexWrap: "wrap" }}>
                                <select
                                    id="check_gubun"
                                    name="check_gubun"
                                    className="form-select"
                                    aria-label="Default select example"
                                    style={{ height: "30px", padding: "0 12px", fontSize: "12px", width: "150px", minWidth: "150px", border: "1px solid #d1d5db", borderRadius: "4px" }}
                                    value={anomalyType}
                                    onChange={(e) => {
                                        setAnomalyType(e.target.value);
                                        setPage(1);
                                        setReload(e => !e);
                                    }}
                                >
                                    <option value="">전체 유형</option>
                                    <option value="HIGH_VALUE">고액 거래</option>
                                    <option value="DUPLICATE">중복 거래</option>
                                    <option value="INSTALLMENT">장기 할부 거래</option>
                                    <option value="MULTI_TRANSACTION">다건 거래</option>
                                </select>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="가맹점 ID"
                                    style={{ height: "30px", padding: "0 10px", fontSize: "12px", width: "150px", minWidth: "150px" }}
                                    value={userId}
                                    onChange={(e) => setUserId(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            onSubmitSearch();
                                        }
                                    }}
                                />
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="최소 금액"
                                    style={{ height: "30px", padding: "0 10px", fontSize: "12px", width: "120px", minWidth: "120px" }}
                                    value={minAmount}
                                    onChange={(e) => setMinAmount(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            onSubmitSearch();
                                        }
                                    }}
                                />
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="최대 금액"
                                    style={{ height: "30px", padding: "0 10px", fontSize: "12px", width: "120px", minWidth: "120px" }}
                                    value={maxAmount}
                                    onChange={(e) => setMaxAmount(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            onSubmitSearch();
                                        }
                                    }}
                                />
                                <div className="button_wrap" style={{ marginTop: "0px" }}>
                                    <button
                                        onClick={onSubmitSearch}
                                        id="tabulator-html-filter-go"
                                        name="searchPayBtn"
                                        type="button"
                                        className="btn btn-primary searchPayBtn"
                                        style={{ height: "30px", whiteSpace: "nowrap" }}
                                    >
                                        검색
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div className="intro-y box intro-padding">
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row", marginBottom: "10px" }}>
                    <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end', margin: "0", width: "100%", gap: "10px" }}>
                        <div className="input_wrap" style={{ background: "#bdcdd6" }}>
                            <label>총 건수 :</label>
                            <input id="total_count" type="text" className="form-control" value={`${changeNum(listData.total || 0)}건`} readOnly disabled />
                        </div>
                    </div>
                </div>
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row" }}>
                    <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end', margin: "0", width: "100%", gap: "10px" }}>
                        <div className="excel-disable">
                            <DownloadBtn text={"엑셀 다운로드"} onClick={excelBtn} />
                        </div>
                    </div>
                </div>
                <div className="div-flex-2 contents" style={{ gap: "20px" }}>
                    <div style={{ width: "100%", maxWidth: "100%" }}>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listData?.total ?? 0}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            listType={true}
                            listState={listState}
                            observerRef={observerRef}
                            nonePage={false}
                            scrollState={true}
                            height={"820px"}
                            spinner={spinner}
                        />
                    </div>
                </div>
            </div>

            {/* 상세 조회 모달 */}
            {detailModal && detailData && (
                <DetailModal
                    detailData={detailData}
                    relatedTransactions={relatedTransactions}
                    memo={memo}
                    setMemo={setMemo}
                    setModal={setDetailModal}
                    updateMemo={updateMemo}
                    onSubmit={onSubmit}
                    MyData={MyData}
                />
            )}
        </div>
    )
}

// 상세 조회 모달 컴포넌트
function DetailModal({ detailData, relatedTransactions, memo, setMemo, setModal, updateMemo, onSubmit, MyData }) {
    return (
        <div id="detail-modal" className="modal show_modal" tabIndex="-1" style={{ display: "block", zIndex: 9999 }}>
            <div className="modal-dialog" style={{ maxWidth: "800px" }}>
                <div className="modal-content marginTop30 modal_sty">
                    <div className="modal-header">
                        <h2 className="font-medium text-base mr-auto">이상 거래 상세 정보</h2>
                        <button
                            className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty"
                            onClick={() => setModal(false)}
                        >
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                        <div className="list-info-box">
                            <div className="box-gap">
                                <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                    <ul>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>검토 ID</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.review_id}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>승인번호</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.approval_id}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>가맹점명</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.merchant_name || detailData.user_id}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>대표자명</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.boss_name || "-"}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>은행</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.bank_nm || "-"}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>계좌번호</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.accnt_no || "-"}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>계좌명</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.accnt_nm || "-"}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>연락처</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.merchant_phone || "-"}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>이메일</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.merchant_email || "-"}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>거래일시</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.transaction_dt}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>금액</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{changeNum(Number(detailData.amount))}원</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>이상거래 유형</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.anomaly_type_kr || detailData.anomaly_type}</span>
                                            </div>
                                        </li>
                                        {detailData.transaction_count && (
                                            <li>
                                                <div className="inner" style={{ width: "100%" }}>
                                                    <span className="left-text" style={{ width: "120px" }}>관련 거래 건수</span>
                                                    <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.transaction_count}건</span>
                                                </div>
                                            </li>
                                        )}
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>검토 상태</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>
                                                    <span style={{ 
                                                        color: detailData.review_status === "PENDING" ? "#f59e0b" : 
                                                               detailData.review_status === "CONFIRMED" ? "#10b981" : "#ef4444"
                                                    }}>
                                                        {detailData.review_status_kr || detailData.review_status}
                                                    </span>
                                                </span>
                                            </div>
                                        </li>
                                        {detailData.admin_id && (
                                            <li>
                                                <div className="inner" style={{ width: "100%" }}>
                                                    <span className="left-text" style={{ width: "120px" }}>처리 관리자</span>
                                                    <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.admin_id}</span>
                                                </div>
                                            </li>
                                        )}
                                        {detailData.reviewed_at && (
                                            <li>
                                                <div className="inner" style={{ width: "100%" }}>
                                                    <span className="left-text" style={{ width: "120px" }}>처리 일시</span>
                                                    <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.reviewed_at}</span>
                                                </div>
                                            </li>
                                        )}
                                        <li>
                                            <div className="inner" style={{ width: "100%", flexDirection: "column", alignItems: "flex-start" }}>
                                                <span className="left-text" style={{ width: "120px", marginBottom: "10px" }}>메모</span>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={memo}
                                                    onChange={(e) => setMemo(e.target.value)}
                                                    placeholder="메모를 입력하세요"
                                                    style={{ width: "100%", fontSize: "12px" }}
                                                />
                                                <button
                                                    className="btn btn-primary mt-2"
                                                    onClick={() => updateMemo(detailData.review_id)}
                                                >
                                                    메모 저장
                                                </button>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* 중복 거래 관련 거래 목록 */}
                        {relatedTransactions.length > 0 && (
                            <div className="mt-4">
                                <h4 className="font-medium mb-3">관련 거래 목록</h4>
                                <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                                    <table className="table table-bordered" style={{ fontSize: "12px" }}>
                                        <thead>
                                            <tr>
                                                <th>거래ID</th>
                                                <th>거래일시</th>
                                                <th>금액</th>
                                                <th>승인번호</th>
                                                <th>구매자명</th>
                                                <th>카드번호</th>
                                                <th>상태</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {relatedTransactions.map((trx, index) => (
                                                <tr key={index}>
                                                    <td>{trx.id}</td>
                                                    <td>{trx.trx_date}</td>
                                                    <td>{changeNum(Number(trx.amt))}원</td>
                                                    <td>{trx.approval_id}</td>
                                                    <td>{trx.buyer_nm || "-"}</td>
                                                    <td>{trx.card_num || "-"}</td>
                                                    <td>{trx.state === "1" ? "정상" : "취소"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* 상태 변경 버튼 (대기중인 경우만) */}
                        {detailData.review_status === "PENDING" && (
                            <div className="mt-4 flex gap-2 justify-end">
                                <button
                                    className="btn btn-success"
                                    onClick={() => {
                                        onSubmit(detailData.review_id, "CONFIRMED");
                                        setModal(false);
                                    }}
                                >
                                    <SquareCheck width={15} height={15} style={{ marginRight: "5px" }} />
                                    확인
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => {
                                        onSubmit(detailData.review_id, "REJECTED");
                                        setModal(false);
                                    }}
                                >
                                    <SquareX width={15} height={15} style={{ marginRight: "5px" }} />
                                    거부
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => setModal(false)}
                        >
                            닫기
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RiskTrx;
